module.exports = __webpack_public_path__ + "img/2-star.1b70ed5d.png";